<template>
  <PanelSignal ref="panelSignal" />
</template>

<script setup>
  import PanelSignal from '@/components/panels/PanelSignal.vue';
</script>

<script>
  export default {
    name: 'PageTrackerHouseSignal',
    data: () => ({
      
    }),
    computed: {
    	signal_id () {
        return this.$route.params.signal_id;
      },
    	house_id () {
        return this.$route.params.house_id;
      },
    	organization_id () {
      	return this.$route.params.organization_id;
    	},
    },
    mounted () {
    	this.$refs.panelSignal.show({
        signal_id: this.signal_id,
      	house_id: this.house_id,
      	organization_id: this.organization_id,
      });
    },
    methods: {
    },
  }
</script>

<style scoped>

</style>